import api from '../api/api';

const API_URL = '/api/v1';

// --- Enums (espelhando o backend para funcionamento mutuo) ---
export enum TipoPessoa {
    FISICA = 'FISICA',
    JURIDICA = 'JURIDICA'
}

export enum EstadoCivil {
    SOLTEIRO = 'SOLTEIRO',
    CASADO = 'CASADO',
    DIVORCIADO = 'DIVORCIADO',
    VIUVO = 'VIUVO',
    UNIAO_ESTAVEL = 'UNIAO_ESTAVEL',
    NAO_INFORMADO = 'NAO_INFORMADO'
}


export enum FaseFunil {
    LEAD_FRIO = 'LEAD_FRIO',
    PROSPECT = 'PROSPECT',
    CLIENTE_ATIVO = 'CLIENTE_ATIVO',
    INATIVO = 'INATIVO'
}

// --- Interfaces de Dados ---

export interface Contrato {
    id: number;
    numeroContrato: string;
    status: string;
}

export interface Cliente {
    id: number;
    tipoPessoa: TipoPessoa;
    nome: string;
    cpfCnpj: string;
    rgIe?: string;
    dataNascimento?: string;
    estadoCivil?: EstadoCivil;
    profissao?: string;
    email: string;
    telefoneWhatsapp?: string;
    telefoneSecundario?: string;
    instagram?: string;
    linkedin?: string;
    cep?: string;
    logradouro?: string;
    numero?: string;
    complemento?: string;
    bairro?: string;
    cidade?: string;
    estadoUf?: string;
    origemLead?: string;
    tagsInteresse?: string;
    faseFunil?: FaseFunil;
    aceitaMarketing?: boolean;
    contratos: Contrato[] | null;
}

export interface ClienteDTO {
    id?: number;
    tipoPessoa?: TipoPessoa;
    nome: string;
    cpfCnpj: string;
    rgIe?: string;
    dataNascimento?: string;
    estadoCivil?: EstadoCivil;
    profissao?: string;
    email: string;
    telefoneWhatsapp?: string;
    telefoneSecundario?: string;
    instagram?: string;
    linkedin?: string;
    cep?: string;
    logradouro?: string;
    numero?: string;
    complemento?: string;
    bairro?: string;
    cidade?: string;
    estadoUf?: string;
    origemLead?: string;
    tagsInteresse?: string;
    faseFunil?: FaseFunil;
    aceitaMarketing?: boolean;
}

export const ClienteFacade = {
    listarTodos: async (): Promise<Cliente[]> => {
        const response = await api.get(`${API_URL}/clientes`);
        if (response.data && Array.isArray(response.data.content)) {
            return response.data.content;
        }
        return Array.isArray(response.data) ? response.data : [];
    },

    buscarPorId: async (id: number): Promise<Cliente> => {
        const response = await api.get(`${API_URL}/clientes/${id}`);
        return response.data;
    },

    criar: async (cliente: ClienteDTO): Promise<Cliente> => {
        const response = await api.post(`${API_URL}/clientes`, cliente);
        return response.data;
    },

    atualizar: async (id: number, cliente: ClienteDTO): Promise<Cliente> => {
        const response = await api.put(`${API_URL}/clientes/${id}`, cliente);
        return response.data;
    },

    excluir: async (id: number): Promise<void> => {
        await api.delete(`${API_URL}/clientes/${id}`);
    }
};